export default __webpack_public_path__ + "static/media/serviceSelection.a76325f7.svg";